<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{name:'xsgl_ddcl_xsdd'}" style="position: absolute;top: 12px;left: 200px;">
			<el-button size="mini">回到销售订单</el-button>
		</router-link>

		<el-form ref="form" label-width="80px">
			<div style="background: #ffffff;border-radius: 5px;border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;" class="m-3">
				<div class="m-3">关联订单</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);margin-bottom: 5px;"></div>
				<div class="m-1">
					<el-table class="mt-2 mb-2" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" size="mini" key="table1" :header-cell-style="{ background: '#f0f1fa' }">
						<el-table-column type="expand" label="产品信息" width="70">
							<template slot-scope="props">
								<el-form label-position="left" inline class="demo-table-expand">
									<el-table :data="tableDataa" style="width: 100%;margin-left: 70px;" key="table2" size="mini" :header-cell-style="{ background: '#f4faf4' }">
										<el-table-column prop="name" label="产品" width="180"></el-table-column>
										<el-table-column prop="noid" label="编码" width="110" align="center"></el-table-column>
										<el-table-column prop="dw" label="单位" width="110" align="center"></el-table-column>
										<el-table-column prop="num" label="数量" width="110" align="center"></el-table-column>
										<el-table-column prop="dj" label="单价" width="110" align="center"></el-table-column>
										<el-table-column prop="hj" label="合计" width="110" align="center"></el-table-column>
									</el-table>
								</el-form>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="id" width="60" label="订单号"></el-table-column>
						<el-table-column align="center" prop="ddje" width="70" label="订单金额"></el-table-column>
						<el-table-column align="center" prop="cjje" width="70" label="成交金额"></el-table-column>
						<el-table-column align="center" prop="djsje" width="80" label="待结算金额"></el-table-column>
						<el-table-column align="center" prop="num" width="70" label="产品数量"></el-table-column>
						<el-table-column align="center" width="100" label="审核状态">
							<template slot-scope="scope">
								<el-button type="success" size="mini" plain>已通过</el-button>
							</template>
						</el-table-column>
						<el-table-column align="center" width="100" label="出入库状态">
							<template slot-scope="scope">
								<el-button type="primary" size="mini" plain>已处理</el-button>
							</template>
						</el-table-column>
						<el-table-column align="center" label="结算状态">
							<template slot-scope="scope">
								<el-button type="info" size="mini" plain>未结算</el-button>
							</template>
						</el-table-column>
						<el-table-column align="center" label="创建人">
							<template slot-scope="scope">
								<el-button type="info" size="mini" plain>我是谁</el-button>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="xdsj" width="140" label="下单时间"></el-table-column>
						<el-table-column align="center" prop="crkrq" width="140" label="出入库日期"></el-table-column>
						<el-table-column align="center" prop="sfkrq" width="140" label="首付款日期"></el-table-column>
					</el-table>
				</div>
			</div>
			<div style="background: #ffffff;border-radius: 5px;border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0 10px -6px;" class="m-3">
				<div class="m-3">关联财务</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);margin-bottom: 5px;"></div>
				<div class="m-1">
					<el-table class="mt-2 mb-2" :data="tableDatab" style="width: 100%" @selection-change="handleSelectionChange" size="mini" key="table3" :header-cell-style="{ background: '#f0f1fa' }">
						<el-table-column align="center" prop="id" label="交易号"></el-table-column>
						<el-table-column align="center" prop="szje" label="收支金额"></el-table-column>
						<el-table-column align="center" label="审核状态">
							<template slot-scope="scope">
								<el-button type="success" size="mini" plain>已通过</el-button>
							</template>
						</el-table-column>
						<el-table-column align="center" label="结算状态">
							<template slot-scope="scope">
								<el-button type="success" size="mini" plain>已结算</el-button>
							</template>
						</el-table-column>
						<el-table-column align="center" label="收款账户">
							<template slot-scope="scope">
								<el-button type="success" size="mini" plain>现金</el-button>
							</template>
						</el-table-column>
						<el-table-column align="center" label="创建人">
							<template slot-scope="scope">
								<el-button type="success" size="mini" plain>我是谁</el-button>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="xdsj" label="下单时间"></el-table-column>
					</el-table>
				</div>
			</div>
		</el-form>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [
					{
						id: 1,
						ddje: 15651,
						cjje: 56554,
						djsje: 5643,
						num: 9643,
						xdsj: '2022-08-22 15:21:21',
						crkrq: '2022-08-22 15:21:21',
						sfkrq: '2022-08-22 15:21:21',
					},
					{
						id: 2,
						ddje: 15651,
						cjje: 56554,
						djsje: 5643,
						num: 9643,
						xdsj: '2022-08-22 15:21:21',
						crkrq: '2022-08-22 15:21:21',
						sfkrq: '2022-08-22 15:21:21',
					}
				],
				tableDataa: [
					{
						name:'文具礼盒',
						noid: 'P1856',
						dw:'盒',
						dj:15,
						num: 15643,
						hj:154521
					}
				],
				tableDatab: [
					{
						id: 'F101856',
						szje:15,
						xdsj: '2022-08-22 15:21:21',
					}
				],
			}
		},
		methods: {
		},
	}
</script>

<style>
	.goods_create .el-form-item {
		margin-bottom: 15px;
	}
	.pt-a{
		padding-top: 20px;
	}
</style>
